import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import IntroAnimation from "./components/IntroAnimation";
import Home from "./pages/Home";
import CoursesHub from "./pages/CoursesHub";
import ADCPart2 from "./pages/ADCPart2";
import NDECC from "./pages/NDECC";
import IrishDental from "./pages/IrishDental";
import USBenchTest from "./pages/USBenchTest";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Enroll from "./pages/Enroll";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  // enroll.overseasdentalachievers.co.in always goes straight to the private enrollment form
  useEffect(() => {
    if (window.location.hostname === "enroll.overseasdentalachievers.co.in") {
      window.location.replace(
        "https://oda-courses.emergent.host/enroll/9pbXRiSnedgLyw_VNykNu4HRQJ4pYeKN"
      );
    }
  }, []);

  return (
    <div className="App">
      {showIntro && <IntroAnimation onComplete={() => setShowIntro(false)} />}
      
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home introComplete={!showIntro} />} />
            <Route path="/courses" element={<CoursesHub />} />
            <Route path="/courses/adc-part-2" element={<ADCPart2 />} />
            <Route path="/courses/ndecc" element={<NDECC />} />
            <Route path="/courses/irish-dental" element={<IrishDental />} />
            <Route path="/courses/us-bench-test" element={<USBenchTest />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/enroll/:token" element={<Enroll />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
